import React, { createContext, useContext, useState } from "react";

// Use toaster context types
import { IToasterContextProps } from "./useToasterContextTypes";
import { Severity } from "../../components/shared/commonTypes/commonTypes";

// Toaster context initialization
const useToasterContext = createContext<IToasterContextProps | undefined>(
  undefined,
);

// Toaster provider component
export const ToasterProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isShowToaster, setIsShowToaster] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState<Severity>("success");
  const [isPersistent, setIsPersistent] = useState(false);

  const setShowToaster = (
    show: boolean,
    message = "",
    severity: Severity = "success",
    isPersistent = false,
  ) => {
    setIsShowToaster(show);
    setMessage(message);
    setSeverity(severity);
    setIsPersistent(isPersistent);
  };

  return (
    <useToasterContext.Provider
      value={{
        isShowToaster,
        message,
        severity,
        isPersistent,
        setShowToaster,
      }}
    >
      {children}
    </useToasterContext.Provider>
  );
};

// User toaster
export const useToaster = () => {
  const context = useContext(useToasterContext);
  if (!context)
    throw new Error("useToaster must be used within a ToasterProvider");
  return context;
};
